type Translate = (key: string, fallback: string) => string;

/**
 * RL-957 S4b — whether a component version is a certified build or a test
 * build, as shown wherever an admin picks a version (owner Q2, 2026-10-22:
 * show only; it blocks nothing). A version from a server that predates the
 * field reads as a test build, as the contract says.
 */
export function certificationLabel(certification: string | undefined, t: Translate): string {
  return certification === 'certified'
    ? t('provision.certification.certified', 'certified')
    : t('provision.certification.test', 'test build');
}
